export default __webpack_public_path__ + "static/1-8f380e3f9cabd173c99c4aee2915bb15.jpg";